// src/App.jsx
import React from 'react';
import Layout from './components/layout/Layout';
import Hero from './components/sections/Hero';
import Stats from './components/sections/Stats';
import Devise from './components/sections/Devise';
import Objectifs from './components/sections/Objectifs';
import Presidence from './components/sections/Presidence';
import Structure from './components/sections/Structure';
import Ressources from './components/sections/Ressources';
import DroitsDevoirs from './components/sections/DroitsDevoirs';
import Galerie from './components/sections/Galerie';
import Videos from './components/sections/Videos';
import Adhesion from './components/sections/Adhesion';
import Contact from './components/sections/Contact';

function App() {
  return (
    <Layout>
      <Hero />
      <Stats />
      <Devise />
      <Objectifs />
      <Presidence />
      <Structure />
      <Ressources />
      <DroitsDevoirs />
      <Galerie />
      <Videos />
      <Adhesion />
      <Contact />
    </Layout>
  );
}

export default App;